<template>
  <header id="header">
    <div class="header-top">
      <div class="header-details">
        <h1 class="header-title">{{ $t('businessName') }}</h1>
        <div class="header-logo">
          <Logo />
        </div>
      </div>
      <div class="header-nav">
        <button 
          v-for="entry in languages" 
          v-bind:class="{'active':(entry.language === lang_current)}"
          :key="entry.title" 
          @click="changeLocale(entry.language)"
        >
          {{entry.title}}    
        </button>
      </div>
    </div>
  </header>
</template>

<script>
  import Logo from '@/components/Logo'
  import i18n from '@/i18n';
  export default {
    name: 'Header',
    data() {    
      return {        
        languages: [            
          { language: 'en', title: 'English' },            
          { language: 'bs', title: 'Bosanski' }     
        ]
      };
    },
    computed: {
      lang_current () {
        return this.$store.getters.lang
      }
    },
    methods: {    
      changeLocale(locale) {
        this.$store.commit('changeLang', locale)  
        i18n.locale = locale;    
      }
    },
    components: {
      Logo
    }
  }
</script>

<style scoped lang="scss">
  #header {
    position: sticky;
    top: 0px;
    z-index: 20;
    
    .header-top {
      @apply bg-purple flex justify-between items-stretch pb-2 shadow-md;

      @screen sm {
        @apply flex-col-reverse items-center;
      }
      border-bottom-right-radius: 40% 3%;
      border-bottom-left-radius: 40% 3%;

      .header-details {
        @apply flex flex-col flex-1;

        .header-title {
          @apply italic pl-6 pt-2 text-white tracking-widest transition-all;

          @screen lg {
            @apply tracking-wider;
          }
          @screen md {
            @apply tracking-wide;
          }
          @screen sm {
            @apply tracking-normal;
          }
        }
        .header-logo {
          @apply block pb-4 pl-4 transition-all;
          max-width: 300px;

          svg {
            @apply block h-auto w-full;
            
          }

          @screen lg {
            max-width: 278px;
          }
          @screen md {
            max-width: 265px;
          }
          @screen sm {
            max-width: 254px;
          }
        }
      }

      .header-nav {
        @apply flex flex-1 justify-end items-start pr-8 pt-4 transition-all;

        @screen xl {
          @apply pr-6;
        }
        @screen lg {
          @apply pr-4;
        }
        @screen md {
          @apply pr-2;
        }
        @screen sm {
          @apply pr-0;
        }

        button {
          @apply text-xs bg-gold ml-2 px-2 py-1 text-white uppercase transition-bg transition-colors;
          border-bottom-right-radius: 3% 30%;
          border-bottom-left-radius: 3% 30%;
          border-top-right-radius: 3% 30%;
          border-top-left-radius: 3% 30%;
          
          &.active {
            @apply bg-pink text-white;
            &:hover,
            &:focus {
              @apply bg-pink text-white;
            }
          }

          &:hover,
          &:focus {
            @apply bg-white text-gold;
          }

          @screen sm {
            @apply px-2 py-1;
          }
        }
      }
    }
  }
  .has-scroll {
    #header {
      .header-top {
        .header-details {
          .header-title {
            @apply pt-0;
            font-size: 8px;
            opacity: 0;
          }
          .header-logo {
            @apply pb-1;
            max-width: 220px;
          }
        }
        .header-nav {
          @apply mt-1;
          @screen sm {
            @apply -my-5;
            opacity: 0;
          }
        }
      }
    }
  }
</style>